"use client";

import { useState } from "react";
import Button, { type ButtonProps } from "src/components/common/Button/Button";
import { submitSignOut } from "src/lib/SignOut";
import { useExtracted } from "#i18n";

export type SignOutButtonProps = Partial<ButtonProps> & { redirectTo?: string };

const SignOutButton = (props: SignOutButtonProps) => {
  const translateMessage = useExtracted();
  const { onClick, redirectTo = "/", ...otherProps } = props;
  const [submitting, setSubmitting] = useState(false);

  return (
    <Button
      label={translateMessage("Sign out")}
      variant={"outline"}
      loading={submitting}
      {...otherProps}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(e);
        setSubmitting(true);
        // The page that loads next is signed out: its response deleted the session cookies.
        submitSignOut(redirectTo);
      }}
    />
  );
};

export default SignOutButton;
